// https://github.com/davidjbradshaw/iframe-resizer-react
import { URL_CHAT_BOT } from '../config';

export const opentItent = (intentName:string) => {
  const chatIframe:HTMLIFrameElement =  document.getElementById('obchat') as HTMLIFrameElement;

  const intent = {
    chat_intent: intentName,
    showIntentAsString: false
  };

  const chatUrl = window.chat_url || URL_CHAT_BOT;
  chatIframe && chatIframe.contentWindow && chatIframe.contentWindow.postMessage(intent, chatUrl);
};
